export interface Course {
  id: string;
  badge: string;
  title: string;
  subtitle: string;
  audience: string;
  description: string;
  modules: number;
  duration: string;
  price: string;
  highlights: string[];
  image: string;
  icon: string;
}

export const courses: Course[] = [
  {
    id: 'soziales-kompetenzen-geistige-beeintraechtigung',
    badge: 'Werkstätten & Förderschulen',
    title: 'Soziales-Kompetenzen & Mindset-Training©',
    subtitle: 'Für Menschen mit geistiger Beeinträchtigung',
    audience: 'Werkstätten für Menschen mit Behinderung · Förderschulen (Förderschwerpunkt geistige Entwicklung)',
    description:
      'Persönliche und soziale Kompetenzen stärken, Selbstwirksamkeit fördern und die Teilnehmenden dabei unterstützen, ihre Stärken wahrzunehmen und wichtige Kompetenzen für ihren persönlichen und beruflichen Weg weiterzuentwickeln.',
    modules: 9,
    duration: '120 Min.',
    price: '899 €',
    highlights: [
      '9 vollständig ausgearbeitete Kursmodule',
      'Zielgruppengerechte Inhalte & Arbeitsblätter',
      'Abwechslungsreiche Methoden und praktische Tools',
      'Direkt eigenständig durch Fachkräfte einsetzbar',
      'Videokurs & Handout für die Kursleitung',
    ],
    image:
      'https://readdy.ai/api/search-image?query=Warm%20still%20life%20of%20a%20tidy%20learning%20table%20with%20printed%20worksheets%2C%20colorful%20rounded%20flashcards%2C%20pencils%20and%20a%20small%20green%20potted%20plant%2C%20soft%20natural%20daylight%20from%20a%20window%2C%20cozy%20educational%20workshop%20setting%2C%20realistic%20high%20quality%20editorial%20photography%2C%20warm%20cream%20and%20olive%20green%20color%20palette%2C%20no%20people%2C%20simple%20clean%20background%2C%20generous%20negative%20space&width=800&height=500&seq=course-geistige-2026-02&orientation=landscape',
    icon: 'ri-heart-3-line',
  },
  {
    id: 'soziales-kompetenzen-psychische-beeintraechtigung',
    badge: 'Werkstätten & Förderschulen',
    title: 'Soziales-Kompetenzen & Mindset-Training©',
    subtitle: 'Für Menschen mit psychischer Beeinträchtigung oder besonderem Unterstützungsbedarf',
    audience: 'Werkstätten · Förderschulen (Förderschwerpunkte ESE & Lernen)',
    description:
      'Persönliche Ressourcen aktivieren, soziale Kompetenzen stärken und einen bewussten Umgang mit Gedanken, Gefühlen und Handlungsmöglichkeiten fördern – für mehr Selbstwirksamkeit im Alltag.',
    modules: 9,
    duration: '120 Min.',
    price: '899 €',
    highlights: [
      '9 vollständig ausgearbeitete Kursmodule',
      'Ressourcen aktivieren & Selbstwirksamkeit fördern',
      'Bewusster Umgang mit Gedanken und Gefühlen',
      'Passende Ergänzung des Bildungsangebots',
      'Videokurs & Handout für die Kursleitung',
    ],
    image:
      'https://readdy.ai/api/search-image?query=Warm%20still%20life%20of%20calming%20learning%20materials%20on%20a%20light%20wooden%20table%2C%20open%20notebook%20with%20gentle%20handwriting%2C%20pastel%20topic%20cards%2C%20a%20cup%20of%20tea%20and%20a%20soft%20green%20plant%2C%20soft%20natural%20window%20light%2C%20peaceful%20supportive%20workshop%20atmosphere%2C%20realistic%20high%20quality%20editorial%20photography%2C%20warm%20cream%20and%20muted%20green%20palette%2C%20no%20people%2C%20clean%20simple%20background&width=800&height=500&seq=course-psychische-2026-02&orientation=landscape',
    icon: 'ri-leaf-line',
  },
  {
    id: 'ready-for-work',
    badge: 'Schulen & Bildungsträger',
    title: 'Ready for Work©',
    subtitle: 'Für Jugendliche in der Berufsvorbereitung',
    audience: 'Schulen · Bildungsträger · Berufsvorbereitung & Berufsorientierung',
    description:
      'Persönlichkeit stärken, Kompetenzen entwickeln und fit für Ausbildung und Arbeitswelt werden – mit besonderem Schwerpunkt auf Vorstellungsgespräche und typische Situationen im beruflichen Alltag.',
    modules: 10,
    duration: '90 Min.',
    price: '1.199 €',
    highlights: [
      '10 vollständig ausgearbeitete Module à 90 Min.',
      'Persönlichkeitsentwicklung & Selbstvertrauen',
      'Soziale Kompetenzen & Teamfähigkeit',
      'Emotionale Selbstregulation',
      'Gezielte Vorbereitung auf Vorstellungsgespräche',
    ],
    image:
      'https://readdy.ai/api/search-image?query=Warm%20still%20life%20of%20career%20preparation%20materials%20on%20a%20wooden%20desk%2C%20a%20neat%20notepad%2C%20a%20pen%2C%20printed%20checklist%20papers%20and%20a%20small%20briefcase%2C%20soft%20natural%20daylight%2C%20focused%20friendly%20atmosphere%20for%20job%20application%20training%2C%20realistic%20high%20quality%20editorial%20photography%2C%20warm%20cream%20and%20olive%20green%20color%20palette%2C%20no%20people%2C%20clean%20simple%20background&width=800&height=500&seq=course-ready-2026-02&orientation=landscape',
    icon: 'ri-rocket-2-line',
  },
];